export class PrescriptionHelper {
    static calcTotalDeliveryQuantity(treatingAnimalsNumber: string | number | undefined, treatmentDays: string | number | undefined, animalDosis: string | number | undefined): number {
        let totalDeliveryQuantity = 0;
        // treatingAnimalsNumber must be defined and treatmentDays or animalDosis must also be defined
        if ((treatingAnimalsNumber !== '' && !Number.isNaN(treatingAnimalsNumber)) && (treatmentDays !== '' && !Number.isNaN(treatmentDays) || animalDosis !== '' && !Number.isNaN(animalDosis))) {
            totalDeliveryQuantity = Number(treatingAnimalsNumber);
            if (treatmentDays !== '' && treatmentDays !== undefined && !Number.isNaN(treatmentDays)) {
                totalDeliveryQuantity = totalDeliveryQuantity * Number(treatmentDays);
            }
            if (animalDosis !== '' && animalDosis !== undefined && !Number.isNaN(animalDosis)) {
                totalDeliveryQuantity = totalDeliveryQuantity * Number(animalDosis);
            }
        }
        return totalDeliveryQuantity;
    }
}